<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Subscriptions</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="" >


  <div class="row">
    <div class="col" >
      <edit-subscription-partner [(ids)]="request"></edit-subscription-partner>
    </div>
  </div>
  <div class="row">
    <div class="col"></div>
    <div class="col-auto">
      <div class="btn btn-primary" (click)="Save()">Speichern</div>
    </div>
  </div>
</div>


<ng-template #successVerTpl> Aktion erfolgreich! </ng-template>
<ng-template #FaildVerTpl> Aktion fehlgeschlagen! </ng-template>
